import type { MessageDescriptor } from 'react-intl';
import { getMessageDescriptorByTranslationKey } from '../getMessageDescriptorByTranslationKey/getMessageDescriptorByTranslationKey';

export function getValidInfoList<T extends Array<{ translationKey: string } | null>>(
  infoList: T,
  messages: Record<string, MessageDescriptor>,
) {
  const valid: Array<NonNullable<T[number] & { messageDescriptor: MessageDescriptor }>> = [];

  infoList.forEach((item) => {
    if (item !== null) {
      const messageDescriptor = getMessageDescriptorByTranslationKey(item.translationKey, messages);

      if (messageDescriptor !== null) {
        valid.push({
          ...item,
          messageDescriptor,
        });
      }
    }
  });
  return valid;
}
